import script from "./myOrderDonePage.vue?vue&type=script&setup=true&lang=js"
export * from "./myOrderDonePage.vue?vue&type=script&setup=true&lang=js"

import "./myOrderDonePage.vue?vue&type=style&index=0&id=36c1ea68&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36c1ea68"]])

export default __exports__